import React from 'react';
import PropTypes from 'prop-types';

import classNames from '../../../utils/classNames';
import { ReactComponent as MinimizeIcon } from '../../../images/minimize-icon.svg';
import { ReactComponent as MaximizeIcon } from '../../../images/maximize-icon.svg';
import './index.scss';

export default function PanelToggleButton({
    isMinimized = false,
    onClick = undefined,
    ariaLabel,
    className = '',
    disabled = false,
    type = 'button',
    title = undefined,
}) {
    const Icon = isMinimized ? MaximizeIcon : MinimizeIcon;

    return (
        <button
            type={type}
            onClick={onClick}
            aria-label={ariaLabel}
            className={classNames('panel-toggle-button', className)}
            disabled={disabled}
            title={title}
        >
            <span className="panel-toggle-button__content" aria-hidden="true">
                <Icon
                    className={classNames(
                        'panel-toggle-button__icon',
                        isMinimized ? 'panel-toggle-button__icon--maximize' : 'panel-toggle-button__icon--minimize',
                    )}
                    focusable="false"
                />
            </span>
        </button>
    );
}

PanelToggleButton.propTypes = {
    isMinimized: PropTypes.bool,
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    title: PropTypes.string,
};
